// extracted by mini-css-extract-plugin
module.exports = {"banner-content":"a10a3f92e9--banner-content--2cXK2","text-box":"a10a3f92e9--text-box--1geGj"};